import { ecommerceContentfulClient as client } from './clients'
import pMemoize from 'p-memoize'
import { Entry } from 'contentful'
import { IProductCategory } from 'types/contentful/productCategory'
import { isProductCustomisable } from 'app/(main)/(catalog)/_components/product/ProductPage/ProductPage.utils'
import { fetchAllEntriesOfType } from './fetch-all-entries-of-type'

const PARENT_CATEGORIES_SLUGS = {
  SAMPLES: 'samples',
  CUSTOM: 'custom-packaging',
  STOCK: 'marketplace',
}

const getSlugsForCustomAndStockProducts = async () => {
  const productCategoriesEntries: Entry<IProductCategory>[] =
    await fetchAllEntriesOfType({
      client,
      contentType: 'productCategory',
    })

  const productSlugs = productCategoriesEntries.map((categoryEntry) => {
    const productSlug =
      categoryEntry?.fields?.urlSlug ||
      categoryEntry?.fields?.productSlug ||
      categoryEntry?.fields?.slug

    if (!productSlug) {
      return null
    }

    if (isProductCustomisable(productSlug)) {
      return `/${PARENT_CATEGORIES_SLUGS.CUSTOM}/${productSlug}/`
    }
    return `/${PARENT_CATEGORIES_SLUGS.STOCK}/${productSlug}/`
  })

  return productSlugs || []
}

async function doLoadAllProductSlugsFromContentful() {
  const customAndStockSlugs = await getSlugsForCustomAndStockProducts()
  const slugs = customAndStockSlugs.filter(Boolean)

  return slugs || []
}

export const loadAllProductSlugsFromContentful = pMemoize(
  doLoadAllProductSlugsFromContentful,
  { maxAge: 1000 * 60 * 5 } // Milliseconds and cache 5 mins
)
